module.exports = __webpack_public_path__ + "static/media/notify.e23f379c.mp3";